import {SierraCanvas} from '../../classes/sierraCanvas';

/**
 * @name resizeImage
 */
export const fastResampleHermite = async (
  canvas: any,
  sourceWidth: number,
  sourceHeight: number,
  outWidth: number,
  outHeight: number
) => {
  if (!canvas || !sourceWidth || !sourceHeight || !outWidth || !outHeight) {
    return canvas;
  }

  if (outWidth > sourceWidth || outHeight > sourceHeight) {
    return canvas;
  }

  const outCnv = new SierraCanvas();
  outCnv.resizeCanvas(outWidth, outHeight);

  const ratioW = sourceWidth / outWidth;
  const ratioH = sourceHeight / outHeight;

  /**
   * This try/catch exists to help debug Sentry issue DASHBOARD-VH
   * @see https://sentry.io/organizations/teemill-tech-ltd/issues/973372662/
   */
  outCnv.drawImage(canvas, 0, 0, outWidth, outHeight);

  outCnv
    .setGlobalAlpha(0.7)
    .drawImage(canvas, 1 / ratioW, 1 / ratioH, outWidth, outHeight);

  const image = await outCnv.toImage();

  outCnv.destroy();

  return image;
};
